'use strict';
window.dataLayer = window.dataLayer || [];

/*
*/
function promotionClick(obj){
    var promoObj = {
        event: 'promotionClick',
        ecommerce: {
            promoClick: {
                promotions: []
            }
        }
    }
    promoObj.ecommerce.promoClick.promotions.push(obj);
    dataLayer.push(promoObj);
}

/**
 * push homepage click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function homePageEvent(eventlabel, eventaction) {
    if (eventlabel && eventaction) {
        dataLayer.push({
            event: 'GAevent',
            eventCategory: 'Homepage Click',
            eventAction: eventaction,
            eventLabel: eventlabel
        });
    }
}

/**
 * push header navigation click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function headerNavigationEvent(eventlabel, eventaction) {
    if (eventlabel && eventaction) {
        dataLayer.push({
            event: 'GAevent',
            eventCategory: 'Header Navigation Click',
            eventAction: eventaction,
            eventLabel: eventlabel
        });
    }
}
/**
 * push footer navigation click analytics events
 * @param {string} eventlabel - Event Label for the event
 * @param {string} eventaction - Event Action for the event
 */
function footerNavigationEvent(eventlabel, eventaction) {
    if (eventlabel && eventaction) {
        dataLayer.push({
            event: 'GAevent',
            eventCategory: 'Footer Navigation Click',
            eventAction: eventaction,
            eventLabel: eventlabel
        });
    }
}

function select_item(gtmData) {
    if (
        gtmData &&
        typeof gtmData === 'object' &&
        !Array.isArray(gtmData) &&
        Object.keys(gtmData).length > 0
    ) {
        // Cleanup unwanted properties
        delete gtmData.currency;
        delete gtmData.currencyCode;
        delete gtmData.search_results_count;
        delete gtmData.search_term;
        delete gtmData.discount_percent;

        // Handle fallback item_list_name/item_list_id
        let itemListName = gtmData.item_list_name;
        if (!itemListName || itemListName.trim() === '') {
            const currentPageType = sessionStorage.getItem('currentPageType') || '';
            itemListName = currentPageType;
            const itemListId = currentPageType.toLowerCase().replace(/\s+/g, '_');
            gtmData.item_list_name = itemListName;
            gtmData.item_list_id = itemListId;
        }

        // Default affiliation
        gtmData.affiliation = gtmData.affiliation || "WGACA";

        // CONDITIONAL BREADCRUMB LOGIC 
        const currentPageType = sessionStorage.getItem('currentPageType') || '';
        const previousPageType = sessionStorage.getItem('previousPageType') || '';

        const skipBreadcrumbs =
            (previousPageType === 'Home Page Featured' && currentPageType === 'PLP Page') ||
            ['Cart Page', 'Wish List Page', 'wishlistshowdetail','PDP Page'].includes(currentPageType);

        if (!skipBreadcrumbs) {
            const productName = (gtmData.item_name || '').trim().toLowerCase();
            const rawCrumbs = Array.from(document.querySelectorAll('.breadcrumb li')).map(el => el.innerText.trim());
            const filteredCrumbs = [...new Set(
                rawCrumbs
                    .map(crumb => crumb.trim())
                    .filter(crumb => {
                        const lowerCrumb = crumb.toLowerCase();
                        return lowerCrumb !== 'home' && lowerCrumb !== productName;
                    })
            )];

            const totalBreadcrumbs = filteredCrumbs.length;
            if (totalBreadcrumbs >= 2) {
                gtmData.item_category = filteredCrumbs[totalBreadcrumbs - 2];
                gtmData.item_category2 = filteredCrumbs[totalBreadcrumbs - 1];
            } else if (totalBreadcrumbs === 1) {
                gtmData.item_category = filteredCrumbs[0];
                gtmData.item_category2 = filteredCrumbs[0];
            } else {
                gtmData.item_category = '';
                gtmData.item_category2 = '';
            }
        } else {
            // Ensure empty category values when skipping breadcrumbs
            gtmData.item_category = '';
            gtmData.item_category2 = '';
        }
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'select_item',
            ecommerce: {
                items: [gtmData]
            }
        });
    }
}

/**
 * @function removeFromCart
 * @description Click event for remove product from cart
 */
function removeFromCart (productObject, quantity) {
    var quantObj = {'quantity': quantity},
        obj = {
            'event': 'removeFromCart',
            'ecommerce': {
                'remove': {
                    'products': []
                }
            }
        };
    obj.ecommerce.remove.products.push($.extend(productObject,quantObj));
    dataLayer.push(obj);
}

/**
 * @function addToWishlist
 * @description Click event for adding product to wishlist
 */
function addToWishlist(productObject) {
    const item = { ...productObject };

    if (item.item_list_name) {
        const currency = productObject.currency || productObject.currencyCode || 'USD';
        delete item.currencyCode;
        delete item.currency;
        delete item.search_results_count;
        delete item.search_term;
        const obj = {
            event: 'add_to_wishlist',
            ecommerce: {
                currency: currency,
                value: Number(productObject.price) || 0,
                items: [item]
            }
        };
        dataLayer.push({ ecommerce: null }); // Clear previous ecommerce data
        dataLayer.push(obj);
        return;
    }

    item.item_brand = productObject.item_brand || productObject.brand;
    item.discount = Number(productObject.discount_price || productObject.discount) || 0;
    item.price = Number(productObject.price) || 0;
    item.affiliation = 'WGACA';

    delete item.brand;
    delete item.discount_price;
    delete item.discount_percent;
    delete item.currencyCode;
    delete item.search_results_count;
    delete item.search_term;
    const productName = (productObject.item_name || '').trim().toLowerCase();
    const rawCrumbs = Array.from(document.querySelectorAll('.breadcrumb li')).map(el => el.innerText.trim());
    const filteredCrumbs = [...new Set(
        rawCrumbs
            .map(crumb => crumb.trim())
            .filter(crumb => {
                const lowerCrumb = crumb.toLowerCase();
                return lowerCrumb !== 'home' && lowerCrumb !== productName;
            })
    )];
    var totalBreadcrumbs = filteredCrumbs.length;
    if (totalBreadcrumbs >= 2) {
        item.item_category = filteredCrumbs[totalBreadcrumbs - 2];
        item.item_category2 = filteredCrumbs[totalBreadcrumbs - 1];
        item.item_category3 = filteredCrumbs[totalBreadcrumbs - 2];
        item.item_category4 = filteredCrumbs[totalBreadcrumbs - 1];
    } else if (totalBreadcrumbs === 1) {
        item.item_category = filteredCrumbs[0];
        item.item_category2 = filteredCrumbs[0];
        item.item_category3 = filteredCrumbs[0];
        item.item_category4 = filteredCrumbs[0];
    } else {
        item.item_category = '';
        item.item_category2 = '';
        item.item_category3 = '';
        item.item_category4 = '';
    }
    var currentPageType = sessionStorage.getItem('currentPageType') || '';
    var listId = currentPageType.toLowerCase().replace(/\s+/g, '_');  
    var listName = currentPageType;
    item.item_list_id = listId;
    item.item_list_name = listName;
    const qty = Number(document.querySelector('select[name="quantity"]')?.value) || 1;
    item.quantity = qty;
    delete item.currency;
    const obj = {
        event: 'add_to_wishlist',
        ecommerce: {
            currency:
                productObject.currency || productObject.currencyCode || 'USD',
            value: item.price,
            items: [item]
        }
    };

    dataLayer.push({ ecommerce: null }); // Clear previous ecommerce data
    dataLayer.push(obj);
}

var events = {
    all: function () {
        $(document).ready(function () {

            $(document).on('click', 'a.header-link', function () {
                var eventaction = $(this).attr('aria-label');
                headerNavigationEvent('My Account', eventaction);
            });
            $(document).on('click', '.wishlist-link', function () {
                var eventaction = 'Wishlist menu';
                headerNavigationEvent($.trim($(this).attr('title')), eventaction);
            });

            $(document).on('click', '.menu-level-1 .nav-item a.nav-link, .menu-level-1 .nav-item a.dropdown-link', function () {
                var eventaction = 'Main Menu';
                headerNavigationEvent($.trim($(this).text()), eventaction);
            });

            $(document).on('click', '.logo-home', function () {
                headerNavigationEvent(window.location.pathname, 'Main Logo');
            });

            $(document).on('click', '.menu-footer a', function () {
                footerNavigationEvent($.trim($(this).text()), 'Footer menu');
            });

            $(document).on('click', '.social-links a', function () {
                footerNavigationEvent($.trim($(this).attr('aria-label')), 'Social Link');
            });

            $(document).on('click', '.postscript a', function () {
                footerNavigationEvent($.trim($(this).text()), 'Footer Link');
            });

            $(document).on('click', '.back-to-top', function () {
                footerNavigationEvent((window.location.pathname), 'Back to top');
            });

            $(document).on('click', '.wishlist-toggle-product', function () {
         
            });
            
            // Push GTM event only when wishlist really toggled
            function pushWishlistEvent($btn) {
                const gtmData = $btn.data('gtmdata') || JSON.parse($btn.attr('data-gtmdata') || '{}');
                if (!gtmData || !gtmData.item_id) return; // extra safe check
            
                addToWishlist(gtmData); // your same function
            }
            
            // Observer: Detect wishlist icon "selected"
            const wishlistClassObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('wishlist-icon') &&
                        mutation.target.classList.contains('selected')
                    ) {
                        const $btn = $(mutation.target).closest('.wishlist-toggle-product');
                        if ($btn.length > 0) {
                            pushWishlistEvent($btn);
                        }
                    }
                }
            });
            
            // Watch DOM for newly added wishlist icons
            const wishlistDomObserver = new MutationObserver((mutationList) => {
                for (const mutation of mutationList) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1 && node.querySelectorAll) {
                            node.querySelectorAll('.wishlist-icon').forEach((el) => {
                                wishlistClassObserver.observe(el, {
                                    attributes: true,
                                    attributeFilter: ['class']
                                });
                            });
                        }
                    });
                }
            });
            
            // Attach observer to already present wishlist icons
            document.querySelectorAll('.wishlist-icon').forEach((el) => {
                wishlistClassObserver.observe(el, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            });
            
            // Attach DOM observer for future dynamic additions
            wishlistDomObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            

            /* $(document).on('click', '.experience-commerce_layouts-slider .hero-background-link', function () {
                homePageEvent($.trim($(this).parent().find('.h1-alt').text()), 'Hero Slider');
            });

            $(document).on('click', '.experience-commerce_assets-popularCategory a.category-tile', function () {
                homePageEvent($.trim($(this).find('.h2-alt').text()), 'Popular Category');
            });

            $(document).on('click', '.experience-commerce_assets-imageAndText a.image-text-block', function () {
                homePageEvent($.trim($(this).find('.btn-tertiary').text()), 'Image text block');
            });

            $(document).on('click', '.experience-commerce_assets-imageAndText a.btn-tertiary, .experience-commerce_assets-imageAndText a', function () {
                homePageEvent($.trim($(this).text()), 'Image text block');
            });
 */


            $(document).on('click', '.experience-component a' , function(e){
                var id ='';
                var name = '';
                var creative = ''
                if ($(e.currentTarget).parents('.experience-component').hasClass('experience-commerce_assets-assetInclude')){
                    id = $(e.currentTarget).parents('.experience-component').find('.content-asset').attr('data-asset-id');
                    name = 'content-asset';
                } else if ($(e.currentTarget).parents('.experience-component').hasClass('.experience-commerce_assets-heroBanner')){
                    id = 'experience-commerce_assets-heroBanner'
                    name = $.trim($(e.currentTarget).text());
                } else if ($(e.currentTarget).parents('.experience-component').hasClass('.experience-commerce_assets-popularCategory')) {
                    id = 'experience-commerce_assets-popularCategory';
                    name = 'Popular Category';
                    creative = $.trim($(e.currentTarget).find('.h2-alt').text());
                } else if ( $(e.currentTarget).parents('.experience-component').hasClass('.experience-commerce_assets-imageAndText')) {
                    id= "experience-commerce_assets-imageAndText";
                    name = $.trim($(this).text());
                    creative = 'Image text block';
                }
                var obj= {}
                obj.name = name;
                obj.id = id;
                obj.creative = creative;
                promotionClick(obj);
            })

            $('body').on('frenzysearch:productitem', function (e, response) {
                let gtmData = JSON.parse(response);
                if (gtmData && gtmData.length > 0) {
                    const { search_term = '', search_results_count = 0 } = gtmData[0];
                    let previousPageType = sessionStorage.getItem('previousPageType') || '';
                    let currentPageType = sessionStorage.getItem('currentPageType') || '';

                    if (previousPageType === 'SKU Search') {
                        if (currentPageType === 'PLP Page' || currentPageType === 'frenzysearch') {
                            previousPageType = 'frenzysearch';
                        }
                    }

                    const listId = previousPageType.toLowerCase().replace(/\s+/g, '_') || '';
                    const listName = previousPageType || '';

                    const productItems = gtmData.map(({ search_term, search_results_count, ...item }) => {
                        return {
                            ...item,
                            item_list_id: listId,
                            item_list_name: listName
                        };
                    });
                    dataLayer.push({
                        event: 'view_search_result',
                        ecommerce: {
                            search_term,
                            search_results_count,
                            items: productItems
                        }
                    });
                }
            });

            $('body').on('frenzyRecommadtion:productitem', function (e, response) {
                let gtmData = JSON.parse(response);
                if (gtmData && gtmData.length > 0) {
                    const { item_list_id, item_list_name } = gtmData[0];
                    dataLayer.push({
                        event: 'view_item_list',
                        ecommerce: {
                            item_list_id,
                            item_list_name,
                            items: gtmData
                        }
                    });
                }
            });

// homepage
$(document).on('click', 'a.product-click-track', function(e) {
    if (
        $(e.target).closest('.wishlist-toggle-product').length > 0 ||
        $(e.target).hasClass('wishlist-toggle-product')
    ) {
        return;
    }
    var $tile = $(this).closest('.product-tile');
    var gtmDataAttr = $tile.find('button[data-gtmdata]').attr('data-gtmdata');
    var gtmData = {};
    try {
        gtmData = JSON.parse(gtmDataAttr);
    } catch (e) {
        console.warn('[Product Click] Invalid data-gtmdata:', e);
    }
    select_item(gtmData);
});

// recently viewed ymal 
$(document).on('click', '.frenzy_product_item a', function (e) {
    if (
        $(e.target).closest('.wishlist-toggle-product').length > 0 ||
        $(e.target).hasClass('wishlist-toggle-product')
    ) {
        return;
    }
    var $tile = $(this).closest('.frenzy_product_item');
    var gtmDataAttr = $tile.find('button[data-gtmdata]').attr('data-gtmdata');
    var gtmData = {};
    try {
        gtmData = JSON.parse(gtmDataAttr);
    } catch (e) {
        console.warn('[Product Click] Invalid data-gtmdata:', e);
    }
    select_item(gtmData);
});

// search plp
$(document).on('click', '.frenzySearchgtm > .frenzy_item', function (e) {
    if (
        $(e.target).closest('.wishlist-toggle-product').length > 0 ||
        $(e.target).hasClass('wishlist-toggle-product')
    ) {
        return;
    }
    var $tile = $(this).closest('.frenzySearchgtm');
    var gtmDataAttr = $tile.attr('data-gtm-data');
    var gtmData = {};
    try {
        gtmData = JSON.parse(gtmDataAttr);        
        select_item(gtmData);
    } catch (err) {
        console.warn('[Product Click] Invalid gtmData:', err);
    }
});

// cart
$(document).on('click', '.card[cypress-target="cartProductCard"] a', function(e) {
    if (
        $(e.target).closest('.wishlist-toggle-product').length > 0 ||
        $(e.target).hasClass('wishlist-toggle-product') ||
        $(e.target).closest('.remove-product').length > 0 ||
        $(e.target).hasClass('remove-product')
    ) {
        return;
    }
    var $card = $(this).closest('.card[cypress-target="cartProductCard"]');
    var gtmDataAttr = $card.find('button[data-gtmdata]').attr('data-gtmdata');
    var gtmData = {};
    try {
        gtmData = JSON.parse(gtmDataAttr);
        delete gtmData.item_category;
        delete gtmData.item_category2;
        select_item(gtmData);
    } catch (e) {
        console.warn('[Cart Product Click] Invalid data-gtmdata:', e);
    }
});


// wishlist
$(document).on('click', '.wishlist-card-product-name a', function (e) {
    var $card = $(this).closest('.wishlist-card-product');
    var gtmDataAttr = $card.find('button[data-gtmdata]').attr('data-gtmdata');
    var gtmData = {};
    try {
        gtmData = JSON.parse(gtmDataAttr);
    } catch (err) {
        console.warn('[Wishlist Product Click] Invalid data-gtmdata:', err);
    }
    select_item(gtmData);
});

// plp
$(document).on('click', '.plp-product-tile a', function (e) {
    if (
        $(e.target).closest('.wishlist-toggle-product').length > 0 ||
        $(e.target).closest('button').length > 0
    ) {
        return;
    }
    var $tile = $(this).closest('.product');
    var gtmDataAttr = $tile.attr('data-gtmdata');
    var gtmData = {};
    try {
        gtmData = JSON.parse(gtmDataAttr);
    } catch (err) {
        console.warn('[PLP Click] Invalid GTM data:', err);
    }
    select_item(gtmData);
});

            $('body').on('click', '.remove-product', function () {
                var $ele = $(this);
                var gmtData = $ele.data('gtmdata') || $.parseJSON($ele.attr('data-gtmdata'));
                var qty = $ele.data('quantity') || $.parseJSON($ele.attr('data-quantity'));
                $('body').on('click', '#removeProductModal .cart-delete-confirmation-btn', function () {
                    removeFromCart(gmtData, qty);
                });
            });
        });
    }
}

module.exports = events;
